import {Component, Input, OnInit} from '@angular/core';
import {BaseDialog} from '../base-dialog';
import {PosizionePrevidenzialePregressa} from '../../../class/lifeproject/retirement/epheso/posizione-previdenziale-pregressa';
import {NbDialogRef} from '@nebular/theme';
import {Router} from '@angular/router';
import {KeyValueStruct} from '../../../class/lifeproject/retirement/epheso/key-value-struct';
import {ApiService} from '../../../service/api.service';
import {EphesoIncome} from '../../../class/lifeproject/retirement/epheso/epheso-income';

@Component({
  selector: 'app-epheso-job-chooser',
  templateUrl: './epheso-job-chooser.component.html',
  styleUrls: ['./epheso-job-chooser.component.css']
})
export class EphesoJobChooserComponent extends BaseDialog<PosizionePrevidenzialePregressa> implements OnInit {

  @Input()
  job: PosizionePrevidenzialePregressa;

  @Input()
  categories: KeyValueStruct[] = [];

  @Input()
  careers: KeyValueStruct[] = [];

  constructor(dialogRef: NbDialogRef<PosizionePrevidenzialePregressa>, route: Router, private apiService: ApiService) {
    super(dialogRef, route);
  }

  ngOnInit() {
    if (!this.job) {
      this.job = new PosizionePrevidenzialePregressa();
    }

    if (!this.job.refIncome) {
      this.job.refIncome = new EphesoIncome();
      this.job.refIncome.net = true;
    }
  }
}
